import {FC} from "react";
import Rating from "@mui/material/Rating";
import Typography from "@mui/material/Typography";

interface IRenderRating {
    value: string;
}

// TODO move to renderers folder to use as generic
export const RenderRating: FC<IRenderRating> = ({value}) => {
    const rating = parseFloat(value);
    if (isNaN(rating)) {
        return (
            <Typography variant="body2" style={{fontWeight: 600}}>
                N/A
            </Typography>
        );
    }

    return (
        <div style={{display: "flex", alignItems: "center"}}>
            <Rating
                name="read-only-rating"
                value={rating}
                precision={0.1}
                readOnly
                sx={{color:theme => theme.palette.common.black}}
            />
        </div>
    );
};


